/** @jsxImportSource @emotion/react */

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import radar from "../../assets/images/radar.png";

import { CustomButton } from "../custom-button/custom-button";

import "./dialog.css";

export const CustomDialog = ({
  children,
  open,
  onClose,
  title,
  actions = [],
  width,
  headerClose = true,
  dialogCss,
  ref,
  ...rest
}) => {
  const dialogTitle = (
    <DialogTitle>
      <img src={radar} alt='' />
      {title && title}
      {headerClose && (
        <IconButton
          aria-label="close"
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      )}
    </DialogTitle>
  );

  const dialogContent = (
    <DialogContent style={{ ...dialogCss }}>
      {children}
    </DialogContent>
  );

  const dialogActions = actions && actions.length > 0 && (
    <DialogActions>
      {actions.map((action, index) => (
        <CustomButton
          key={index}
          {...action}
        />
      ))}
    </DialogActions>
  );

  return (
    <Dialog
      ref={ref}
      open={open}
      onClose={onClose}
      aria-labelledby={title || "dialog-title"}
      aria-describedby={title || "dialog-description"}
      css={emotion.dialog(width)}
      {...rest}
    >
      {dialogTitle}
      {dialogContent}
      {dialogActions}
    </Dialog>
  );
}

const emotion = {
  dialog: (width) => ({
    ".MuiDialog-container": {
      ".MuiPaper-root": {
        width,
      },
    },
  })
};
